import AppService from "./app.service";

const CohortService = () => {
  return Object.freeze({
    saveCohort: async (cohortData, url) => {
      return await AppService.submit(cohortData, url);
    },

    getCohort: async (cohortId, url) => {
      return await AppService.get(cohortId, url);
    },

    assignSimulationsToCohort: async (cohort) => {
      const assignSimulations = await AppService.submit(
        cohort,
        "cohorts/assignSimulations"
      );
    },

    getCohrotWithAssignedSimulations: async (cohortId) => {
      const cohort = AppService.get(
        cohortId,
        "cohorts/getCohortWithAssignedSimulations"
      );
      return cohort;
    },

    assignAssignmentToCohort: async (cohort) => {
      await AppService.submit(cohort, "cohorts/assignAssignment");
    },

    getCohortParticipantInSightsDashboardData: async (params) => {
      return await AppService.submit(
        params,
        "cohorts/getDashboardDataByCohortId"
      );
    },

    updateCohortParticipantProgressStatus: async (params) => {
      return await AppService.submit(
        params,
        "cohortParticipant/updateProgressStatus"
      );
    },

    generateCohortReport: async (params) => {
      return await AppService.submit(params, "educatorInsight/report");
    },

    getActiveCohorts: async (cohortId) => {
      return await AppService.get(cohortId, "cohorts/getAllActiveForCohorts");
    },

    assignSurveyToCohort: async (params) => {
      return await AppService.submit(params, "cohorts/assignSurvey");
    },

    getCohortSurvey: async (params) => {
      return await AppService.submit(params, "cohorts/getCohortSurvey");
    },

    getCohortParticipantsEmail: async (cohortId) => {
      return await AppService.getAllWithData(
        "cohortParticipant/emailsByCohort",
        cohortId
      );
    },

    resendSurveyToParticipant: async (id) => {
      return await AppService.get(id, "cohorts/resendSurvey");
    },

    getCohortSurveySchedule: async (cohortId) => {
      return await AppService.get(cohortId, "cohorts/cohortSchedule");
    },

    checkCohortSurveyLink: async (encryptedString) => {
      return await AppService.getAllWithData(
        "cohorts/checkSurveyLink",
        encryptedString
      );
    },
  });
};

export default CohortService;
